// extracted by mini-css-extract-plugin
module.exports = {"moveMenuWrapper":"MovePopup_moveMenuWrapper__LGbf3","attendeesHolder":"MovePopup_attendeesHolder__1FfKj"};